/**
 * @generated SignedSource<<e6d9d9a1f71133e95fb912ff8ab3abb9>>
 * @relayHash 80182b4ec73bdbb3ec3655c7cbdbf0ec
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 57be59499c73a8ec97d64e0b3743b70ee64e51b67502f498cc533ae154f2ae7c

import type { ConcreteRequest } from 'relay-runtime';
export type PromoteInferredProjectSectionCurrentUserQuery$variables = Record<PropertyKey, never>;
export type PromoteInferredProjectSectionCurrentUserQuery$data = {
  readonly me: {
    readonly user: {
      readonly accountId: string;
    } | null;
  };
};
export type PromoteInferredProjectSectionCurrentUserQuery = {
  response: PromoteInferredProjectSectionCurrentUserQuery$data;
  variables: PromoteInferredProjectSectionCurrentUserQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "accountId"
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "PromoteInferredProjectSectionCurrentUserQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v0/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PromoteInferredProjectSectionCurrentUserQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              (v0/*: any*/),
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "57be59499c73a8ec97d64e0b3743b70ee64e51b67502f498cc533ae154f2ae7c",
    "metadata": {},
    "name": "PromoteInferredProjectSectionCurrentUserQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "b65961cff9fe56750b2880452a7dce9d";

export default node;
